import type { InspectionBinBounds } from './inspectionBinBounds'

export function inspectionExtremum(
  values: ArrayLike<number>,
  width: number,
  focus: 'minimum' | 'maximum',
  bounds?: InspectionBinBounds | null
) {
  if (!Number.isInteger(width) || width <= 0) return undefined
  let index = -1
  let value = focus === 'minimum' ? Infinity : -Infinity
  for (let i = 0; i < values.length; i++) {
    if (
      bounds &&
      (i % width < bounds.x_start ||
        i % width >= bounds.x_end ||
        Math.floor(i / width) < bounds.y_start ||
        Math.floor(i / width) >= bounds.y_end)
    )
      continue
    const candidate = values[i]
    if (!Number.isFinite(candidate)) continue
    if (
      index < 0 ||
      (focus === 'minimum' ? candidate < value : candidate > value)
    ) {
      index = i
      value = candidate
    }
  }
  return index < 0 || width <= 0
    ? undefined
    : { x: index % width, y: Math.floor(index / width), value }
}
